export { BingMap } from './src/bing-map';
export { BingMapsContext } from './src/bing-maps-context';
export { BingMapsContextProvider } from './src/bing-maps-context-provider';
export { LocationService } from './src/location-service';
export { useLocationsFromBingMapsApi } from './src/use-locations-from-bing-maps-api';

